import jBinary from 'jbinary';
console.log(jBinary.Template);

export let netStringTypeset = {
  NET_String: jBinary.Template({
    baseType: {
      length: jBinary.Type({
        read: function() {
          var view = this.view;
          var count = 0;
          var shift = 0;
          var b;
          do {
            // Check for a corrupted stream.  Read a max of 5 bytes.
            // In a future version, add a DataFormatException.
            if (shift == 5 * 7)
              // 5 bytes max per Int32, shift += 7
              throw 'Format_Bad7BitInt32';

            // ReadByte handles end of stream cases for us.
            b = view.getInt8();
            count |= (b & 0x7f) << shift;
            shift += 7;
          } while ((b & 0x80) != 0);
          return count;
        },
        write: function(value) {
          var view = this.view;
          while (value >= 0x80) {
            view.writeInt8(value | 0x80);
            value >>= 7;
          }
          view.writeInt8(value);
        },
      }),
      str: ['string', 'length'],
    },
    read: function() {
      return this.baseRead().str;
    },
    write: function(str) {
      this.baseWrite({
        length: str.length,
        str: str,
      });
    },
  }),
};
